/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Actions_EditInputs */

const es_admin_users_actions_edit = /** @type {(inputs: Admin_Users_Actions_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar Usuario`)
};

const en_admin_users_actions_edit = /** @type {(inputs: Admin_Users_Actions_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit User`)
};

/**
* | output |
* | --- |
* | "Edit User" |
*
* @param {Admin_Users_Actions_EditInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_users_actions_edit = /** @type {((inputs?: Admin_Users_Actions_EditInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Actions_EditInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_users_actions_edit(inputs)
	return en_admin_users_actions_edit(inputs)
});
export { admin_users_actions_edit as "admin.users.actions.edit" }